/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, Tag } from "antd";
import { PlusIcon } from "../../../../../../../../atoms/CustomIcons";
import MinusIcon from "../../../../../../../../atoms/CustomIcons/MinusIcon";

interface PropsType {
  estimateChanges?: any[];
  apiData?: any;
  finalTotalAmount: number;
}

export default function ChangeList(props: PropsType) {
  const { estimateChanges, apiData, finalTotalAmount } = props;

  return (
    <div className="changeList">
      {estimateChanges &&
        estimateChanges?.length > 0 &&
        estimateChanges.map((change) => {
          let quantityAdded = null;
          let quantityRemoved = null;
          let visitsAdded = null;
          let visitsRemoved = null;
          let totalPriceAdded = null;
          let totalPriceRemoved = null;

          if (
            apiData &&
            apiData?.total_amount &&
            finalTotalAmount > apiData?.total_amount
          ) {
            totalPriceAdded = finalTotalAmount - apiData?.total_amount;
            totalPriceRemoved = null;
          } else if (
            apiData &&
            apiData?.total_amount &&
            apiData?.total_amount > finalTotalAmount
          ) {
            totalPriceRemoved = apiData?.total_amount - finalTotalAmount;
            totalPriceAdded = null;
          }

          if (
            change.type === "subservice" &&
            change.change_field === "quantity"
          ) {
            if (change.newValue > change.oldValue) {
              quantityAdded = change.newValue - change.oldValue;
              quantityRemoved = null;
            } else if (change.newValue < change.oldValue) {
              quantityRemoved = change.oldValue - change.newValue;
              quantityAdded = null;
            }
          }

          if (
            change.type === "subservice" &&
            change.change_field === "visits"
          ) {
            if (change.newValue > change.oldValue) {
              visitsAdded = change.newValue - change.oldValue;
              visitsRemoved = null;
            } else if (change.newValue < change.oldValue) {
              visitsRemoved = change.oldValue - change.newValue;
              visitsAdded = null;
            }
          }
          console.log(
            "finalTotalAmount",
            apiData?.total_amount,
            totalPriceAdded,
            totalPriceRemoved
          );
          return (
            <>
              {change.type === "service" &&
                change.change_field === "added_service" && (
                  <Card className="list_card">
                    <Card style={{ marginBottom: "4px" }}>
                      <div className="title">
                        <span className="for_icon_green">
                          <PlusIcon />
                        </span>

                        {change.parent_service ? (
                          <span>
                            {change.service_name} added to{" "}
                            {change.parent_service}.
                          </span>
                        ) : (
                          <span>{change.service_name} added.</span>
                        )}
                      </div>
                    </Card>

                    <div className="content">
                      {change.parent_service
                        ? `${change.service_name} will be added to work order.`
                        : "New work order will be created."}
                    </div>
                  </Card>
                )}

              {change.type === "subservice" &&
                change.change_field === "quantity" &&
                (quantityAdded || quantityRemoved) && (
                  <Card className="list_card">
                    <Card style={{ marginBottom: "4px" }}>
                      <div className="title">
                        {quantityAdded && (
                          <>
                            <span className="for_icon_green">
                              <PlusIcon />
                            </span>
                            {quantityAdded.toLocaleString()}
                            {change.unit ?? ""} added to{" "}
                            {change.subservice_name}.
                          </>
                        )}

                        {quantityRemoved && (
                          <>
                            <span className="for_icon_red">
                              <MinusIcon />
                            </span>
                            {quantityRemoved.toLocaleString()}
                            {change.unit ?? ""} removed from{" "}
                            {change.subservice_name}.
                          </>
                        )}
                      </div>
                    </Card>

                    <div className="content">
                      The difference of $10,000 will spread across all remaining
                      invoices.
                    </div>
                  </Card>
                )}

              {change.type === "subservice" &&
                change.change_field === "visits" &&
                (visitsAdded || visitsRemoved) && (
                  <Tag color="blue" className="change_order_tag">
                    {visitsAdded &&
                      `${visitsAdded} ${
                        visitsAdded === 1 ? "visit" : "visits"
                      } added to ${change.subservice_name}.`}
                    {visitsRemoved &&
                      `${visitsRemoved} ${
                        visitsRemoved === 1 ? "visit" : "visits"
                      } removed from ${change.subservice_name}.`}
                  </Tag>
                )}

              {change.type === "priceRemoved" &&
                change.change_field === "priceRemoved" && (
                  <Card className="list_card">
                    <Card style={{ marginBottom: "4px" }}>
                      <div className="title">
                        <span className="for_icon_red">
                          <MinusIcon />
                        </span>
                        ${Number(change?.oldValue?.toFixed(2)).toLocaleString()}{" "}
                        removed from contract amount.
                      </div>
                    </Card>

                    <div className="content">
                      This reduction will be spread across all remaining monthly
                      invoices.
                    </div>
                  </Card>
                )}

              {/* {(totalPriceAdded || totalPriceRemoved) &&
                index === estimateChanges.length - 1 && (
                  <Card className="list_card">
                    <Card style={{ marginBottom: "4px" }}>
                      <div className="title">
                        {totalPriceAdded && (
                          <>
                            <span className="for_icon_green">
                              <PlusIcon />
                            </span>
                            $
                            {Number(
                              totalPriceAdded.toFixed(2)
                            ).toLocaleString()}{" "}
                            added to contract amount.
                          </>
                        )}

                        {totalPriceRemoved && (
                          <>
                            <span className="for_icon_red">
                              <MinusIcon />
                            </span>
                            $
                            {Number(
                              totalPriceRemoved.toFixed(2)
                            ).toLocaleString()}{" "}
                            removed from contract amount.
                          </>
                        )}
                      </div>
                    </Card>

                    <div className="content">
                      The difference of $10,000 will spread across all remaining
                      invoices.
                    </div>
                  </Card>
                )} */}

              {change.type === "subserviceRemoved" &&
                change.change_field === "delete" && (
                  <Card className="list_card">
                    <Card style={{ marginBottom: "4px" }}>
                      <div className="title">
                        <span className="for_icon_red">
                          <MinusIcon />
                        </span>
                        Subservice {change.subservice_name} removed from{" "}
                        {change.service_name}.
                      </div>
                    </Card>

                    <div className="content">
                      This service will be removed from work order.
                    </div>
                  </Card>
                )}

              {change.type === "serviceRemoved" &&
                change.change_field === "delete" && (
                  <Card className="list_card">
                    <Card style={{ marginBottom: "4px" }}>
                      <div className="title">
                        <span className="for_icon_red">
                          <MinusIcon />
                        </span>
                        Service {change.service_name} is removed.
                      </div>
                    </Card>

                    <div className="content">Work order will be removed.</div>
                  </Card>
                )}
            </>
          );
        })}

      {/* <Card className="list_card">
        <Card style={{ marginBottom: "4px" }}>
          <div className="title">
            <span className="for_icon_red">
              <PlusIcon />
            </span>
            Weed Defence quantity changes from $18,000 to 20,000 sf
          </div>
        </Card>

        <div className="content">
          Labor hours and material need will increase in the work order.
        </div>
      </Card>

      <Card className="list_card">
        <Card style={{ marginBottom: "4px" }}>
          <div className="title">
            <span className="for_icon_red">
              <PlusIcon />
            </span>
            Bed edging is added to Weekly service
          </div>
        </Card>

        <div className="content">
          Bed edging will be added to the remaining visits, including already
          scheduled visits. <br /> <br />
          Routes with scheduled visits will be updated as total number of hours
          is increasing.
        </div>
      </Card>

      <Card className="list_card">
        <Card style={{ marginBottom: "4px" }}>
          <div className="title">
            <span className="for_icon_green">
              <MinusIcon />
            </span>
            Pruning is removed
          </div>
        </Card>

        <div className="content">Work order will be deleted.</div>
      </Card> */}
    </div>
  );
}
